<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
html,
body {
  width: 100%;
  height: 100%;
  min-width: 1366px;
  scroll-behavior: smooth;
}
ul li {
  list-style-type: none;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
  margin: 0;
  padding: 0;
  /* width: 100%; */
  height: 100%;
}
.el-footer{
  padding: 0px;
}
.el-header{
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue